import { Button, mergeClasses } from '@fluentui/react-components';
import { useMemo } from 'react';
import { useMainButtonStyles } from './MainButton.styles';
import { IMainButtonProp } from './MainButton.types';

const MainButton = (props: IMainButtonProp) => {
    const { dataTestId, onClick, text, type, className } = props;

    const styles = useMainButtonStyles();

    const buttonClassName = useMemo(() => {
        return mergeClasses(
            styles.button,
            type === 'outlinedBlackText' && styles.outlinedBlackText,
            type === 'outlinedWhiteText' && styles.outlinedWhiteText,
            type === 'outlinedBlueText' && styles.outlinedBlueText,
            type === 'soft' && styles.soft,
            type === 'primary' && styles.primary,
            type === 'link' && styles.link,
            type === 'redText' && styles.redText,
            type === 'solidRed' && styles.solidRed,
            className
        );
    }, [type]);

    return (
        <Button className={buttonClassName} onClick={onClick} data-testid={dataTestId}>
            {text}
        </Button>
    );
};

export default MainButton;
